import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { updateSettings } from "../../api/apiSettings";

export const useUpdateSettings = () => {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || "en").startsWith("ar");

    const mutation = useMutation({
        mutationFn: (data) => {
            // Flatten grouped sections into top-level keys for the API
            const flat = {};
            Object.values(data).forEach((section) => {
                if (section && typeof section === 'object') {
                    Object.assign(flat, section);
                }
            });
            return updateSettings(flat);
        },
        onSuccess: (response) => {
            queryClient.invalidateQueries({ queryKey: ["settings"] });
            toast.success(
                response?.message ||
                (isArabic ? "تم حفظ الإعدادات" : "Settings saved")
            );
        },
        onError: (error) => {
            const message =
                error?.response?.data?.message ||
                (isArabic ? "تعذر حفظ الإعدادات" : "Failed to save settings");
            toast.error(message);
        },
    });

    return mutation;
};
